<mat-card class="topTerminals" #terminalsChart>
  <mat-card-header class="cardHeader">
    <mat-card-title>
      <span
        *ngIf="!terminalsTableVisible"
        i18n="storeSummaryTopTerminalsChartTitle|store Summary Top Terminals Chart Title@@storeSummary_topTerminalsChartTitle"
        >Top Terminais</span
      >
      <span
        *ngIf="terminalsTableVisible"
        i18n="storeSummaryTopTerminalsTableTitle|store Summary Top Terminals Table Title@@storeSummary_topTerminalsTableTitle"
        >Vendas | Terminais</span
      >
    </mat-card-title>
    <mat-card-subtitle *ngIf="topTerminalsData?.length" (click)="showMoreTerminalSales()" class="showMoreButton">
      <span
        *ngIf="!terminalsTableVisible"
        i18n="storeSummaryChartsShowMoreSubTitle|store Summary Charts Show More SubTitle@@storeSummary_chartsShowMoreSubTitle"
        >Ver mais</span
      >
      <span
        *ngIf="terminalsTableVisible"
        i18n="storeSummaryChartsShowLessSubTitle|store Summary Charts Show Less SubTitle@@storeSummary_chartsShowLessSubTitle"
        >Ver menos</span
      >
    </mat-card-subtitle>
    <div class="parameters">
      <mat-form-field class="dateInterval">
        <mat-select [(value)]="selectedTerminalDate" (selectionChange)="terminalIntervalChanged()">
          <mat-option *ngFor="let date of topsInterval" [value]="date">
            {{ date.description }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-icon (click)="terminalIntervalChanged()" class="refreshButton">cached</mat-icon>
      <button mat-icon-button class="export-button" [matMenuTriggerFor]="menu"><mat-icon>more_vert</mat-icon></button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item [matMenuTriggerFor]="chartExportTo"
          ><mat-icon>donut_small</mat-icon><span i18n="ExportChartButton|Export Chart Button@@export_chart">Exportar Gráfico</span></button
        >
        <button mat-menu-item [matMenuTriggerFor]="tableExportTo"
          ><mat-icon>document_scanner</mat-icon
          ><span i18n="ExportTableButton|Export Table Button@@export_table">Exportar Tabela</span></button
        >
      </mat-menu>
      <mat-menu #chartExportTo="matMenu">
        <button mat-menu-item (click)="exportChartPdf()">PDF</button>
        <button mat-menu-item (click)="exportChartPng()">PNG</button>
      </mat-menu>
      <mat-menu #tableExportTo="matMenu">
        <button mat-menu-item (click)="exportXlSX()">XLS</button>
      </mat-menu>
    </div>
  </mat-card-header>
  <ng-container *ngIf="topTerminals$ | async">
    <ng-container *ngIf="topTerminalsData?.length; else emptyChart">
      <ng-container *ngIf="!terminalsTableVisible">
        <mat-card-content class="topTerminalsContent">
          <dx-pie-chart class="chart" type="pie" [dataSource]="topTerminalsData">
            <dxi-series argumentField="terminalDescription" valueField="total"></dxi-series>
            <dxo-tooltip enabled="true" [zIndex]="5000" [customizeTooltip]="customizeTopsTooltip"></dxo-tooltip>
            <dxo-margin [top]="22" [bottom]="38" [left]="20"></dxo-margin>
          </dx-pie-chart>
        </mat-card-content>
      </ng-container>
      <ng-container *ngIf="terminalsTableVisible">
        <mat-card-content class="topTerminalsTableContent">
          <table class="topTerminalsTable" mat-table [dataSource]="topTerminalsDataSource">
            <ng-container [matColumnDef]="col" *ngFor="let col of topTerminalsTableColumns">
              <ng-container *ngIf="col === 'storeName' || col === 'terminalDescription' || col === 'storeId' || col === 'terminalId'">
                <th class="tableHeaders" mat-header-cell *matHeaderCellDef> {{ col | translate }} </th>
                <td class="tableCells" mat-cell *matCellDef="let element"> {{ element[col] }} </td>
              </ng-container>
              <ng-container *ngIf="col !== 'storeName' && col !== 'terminalDescription' && col !== 'storeId' && col !== 'terminalId'">
                <th class="tableHeaders" mat-header-cell *matHeaderCellDef> {{ col | translate }} </th>
                <td class="tableCells" mat-cell *matCellDef="let element"> {{ element[col] | cloudCurrency }}</td>
              </ng-container>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="topTerminalsTableColumns; sticky: true"></tr>
            <tr class="tableRows" mat-row *matRowDef="let row; columns: topTerminalsTableColumns"></tr>
          </table>
        </mat-card-content>
      </ng-container>
    </ng-container>
  </ng-container>
</mat-card>

<ng-template #emptyChart>
  <div class="center-error">
    <div class="pl-3 pr-3">
      <p class="col text-center text-color"
      i18n="storeSummaryEmptyChartTitle|store Summary Empty Chart Title@@storeSummary_emptyChartTitle">
      Não foram encontradas vendas para os parametros selecionados.</p>
      <p class="col text-center text-color"
        i18n="storeSummaryEmptyChartSubTitle|store Summary Empty Chart SubTitle@@storeSummary_emptyChartSubTitle">
        As lojas selecionadas poderão ter estado encerradas durante o intervalo de tempo selecionado.</p>
    </div>
  </div>
</ng-template>
